import React, { Component } from 'react';
import { Phone, Calendar, MessageCircle, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
export function QuickActionBar() {
  const actions = [{
    icon: <Phone className="w-6 h-6" data-id="element-197" data-mp="3eavi9njpt2sv" />,
    title: 'Call Us Today',
    desc: '+267 6540244',
    href: 'tel:+2676540244',
    color: 'bg-brand-navy',
    hover: 'hover:bg-blue-900'
  }, {
    icon: <Calendar className="w-6 h-6" data-id="element-198" data-mp="2lmhib292fweo" />,
    title: 'Book Appointment',
    desc: 'Schedule online',
    href: '/book',
    color: 'bg-brand-red',
    hover: 'hover:bg-red-700'
  }, {
    icon: <MessageCircle className="w-6 h-6" data-id="element-199" data-mp="2gpr7oug15t0n" />,
    title: 'WhatsApp Us',
    desc: '+267 73241613',
    href: 'https://wa.me/26773241613',
    color: 'bg-[#25D366]',
    hover: 'hover:bg-[#20bd5a]'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-200" data-mp="aueq5xvwl6gi" />,
    title: 'Operating Hours',
    desc: "Mon-Fri: 8am-6pm | Sat : 9am-1pm",
    href: '/contact',
    color: 'bg-brand-gold',
    hover: 'hover:bg-[#7a6646]'
  }];
  return <div className="relative z-40 -mt-10 max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201" data-mp="2p3zn8gq88zht">
      <div className="bg-white rounded-2xl shadow-soft-lg p-2 flex flex-col md:flex-row" data-id="element-202" data-mp="2p6dfkhtivxlo">
        {actions.map((action, idx) => {
        const isExternal = action.href.startsWith('http') || action.href.startsWith('tel');
        const Component = isExternal ? 'a' : Link;
        const props = isExternal ? {
          href: action.href,
          target: action.href.startsWith('http') ? '_blank' : undefined
        } : {
          to: action.href
        };
        return <Component key={idx} {...props} className={`flex-1 flex items-center gap-4 p-4 md:p-6 rounded-xl transition-all duration-300 group ${action.hover} hover:-translate-y-1`} data-id="element-203" data-mp="2bd49aq0vfs7d" data-mpi={idx}>
              <div className={`w-12 h-12 rounded-full ${action.color} text-white flex items-center justify-center shrink-0 shadow-md group-hover:scale-110 transition-transform`} data-id="element-204" data-mp="2k5y1tp5bwo36">
                {action.icon}
              </div>
              <div data-id="element-205" data-mp="1rmsgz34gocpf">
                <h3 className="font-heading font-semibold text-slate-800 group-hover:text-brand-navy transition-colors" data-id="element-206" data-mp="2uzj4cx3npr0k">
                  {action.title}
                </h3>
                <p className="text-sm text-slate-500 group-hover:text-slate-700" data-id="element-207" data-mp="2q068jmut59lu">
                  {action.desc}
                </p>
              </div>
            </Component>;
      })}
      </div>
    </div>;
}